import { Product } from './products'

/** Natural-category spa water-care products currently listed in the Pegasus online catalog. */
export const naturalChemicalProducts: Product[] = [
  {
    name: 'Spa Purge',
    sku: '12558',
    price: 25.0,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/spa%20purge.png400x400.png',
    alt: 'Bottle of Spa Purge plumbing cleaner',
  },
  {
    name: 'Filter Perfect',
    sku: '12556',
    price: 25.0,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/filter%20perfect.png400x400.png',
    alt: 'Bottle of Filter Perfect filter cleaner',
  },
  {
    name: 'Clean & Perfect',
    sku: '12554',
    price: 15.99,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/clean%20perfect.png400x400.png',
    alt: 'Bottle of Clean & Perfect spa surface cleaner',
  },
  {
    name: 'Spa Perfect',
    sku: '12560',
    price: 21.95,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/spa%20perfect.png400x400.png',
    alt: 'Bottle of Spa Perfect enzyme-based spa water product',
  },
  {
    name: 'Spa Metal Free',
    sku: '12559',
    price: 25.0,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/Metal%20free.png400x400.png',
    alt: 'Bottle of Spa Metal Free metal-control product',
  },
  {
    name: 'SunPurity Mineral Purifier',
    sku: '13181',
    price: 38.9,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/download%20%281%29.jpg',
    alt: 'SunPurity mineral purifier cartridge for spa water',
  },
]
